import * as React from 'react';

import { isConnectedSelector } from 'src/selectors/isConnected';
import { isConnectingSelector } from 'src/selectors/isConnecting';
import { isRefreshingDatabasesSelector } from 'src/selectors/isRefreshingDatabases';
import { isVoiceboxPendingSelector } from 'src/selectors/voicebox';
import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const useMessageLineInfo = () => {
  const isConnected = useReduxSelector(isConnectedSelector);
  const isConnecting = useReduxSelector(isConnectingSelector);
  const isRefreshingDatabases = useReduxSelector(isRefreshingDatabasesSelector);
  const isPendingMessage = useReduxSelector(isVoiceboxPendingSelector);

  const { disabled, disabledReason, pending } = React.useMemo(() => {
    let disabledReason = '';
    if (isPendingMessage) {
      disabledReason = copy.components.voicebox.disabledReasons.messagePending;
    } else if (isConnecting) {
      disabledReason =
        copy.components.voicebox.disabledReasons.stardogConnecting;
    } else if (isRefreshingDatabases) {
      disabledReason =
        copy.components.voicebox.disabledReasons.databasesRefreshing;
    } else if (!isConnected) {
      disabledReason =
        copy.components.voicebox.disabledReasons.stardogNotConnected;
    }

    const pending = isPendingMessage || isConnecting || isRefreshingDatabases;

    return {
      disabled: Boolean(disabledReason || pending),
      disabledReason,
      pending,
    };
  }, [isConnecting, isRefreshingDatabases, isConnected, isPendingMessage]);

  return {
    disabled,
    disabledReason,
    pending,
  };
};
